export default __webpack_public_path__ + "static/media/speciality_id_6.5a48e19d.png";